export const formatDate = (date) => {
    if (!date || typeof date !== 'string') return '';
  
    const datePart = date.split('-');
    if (datePart.length !== 3) return '';
  
    const [year, month, day] = datePart;
    if (
      isNaN(year) || year.length !== 4 ||
      isNaN(month) || +month < 1 || +month > 12 ||
      isNaN(day) || +day < 1 || +day > 31
    ) {
      return '';
    }
  
    return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
  };
  